export { default as Admin } from './Home';
export {default as AdminLogin} from './AdminLogin';
export {default as Orderlist} from './Orderlist';
export {default as FinishOrderlist} from './FinishOrderlist';
export {default as PendingMessage} from './PendingMessage';
export {default as AddUser} from './AddUser';
export {default as AddProducts} from './AddProducts';